import React from 'react';
import '../assets/css/style.css';
import call from'../assets/css/img/call.png';
import linkedin from '../assets/css/img/in.png';
import fb from '../assets/css/img/fb.png';
import insta from '../assets/css/img/insta.png';
import youtube from '../assets/css/img/youtube.png';
import msg from "../assets/css/img/msg.png";
import location from '../assets/css/img/location.png';


const Footer = () => {
  return (
    <footer className="footer" >
      <div className="footer-content">
        <div className="footer-left">
       
          <h1>Visit Us</h1>
          {/* <a href="mailto:Ram@axissolar.in" target='_blank'><img src={msg} className='p-2'/><small style={{ color: '#fff',textDecoration:"none"}}>Ram@axissolar.in</small></a><br></br>
          <a href="tel:+91-8999 999 108"target='_blank'><img src={call} className='p-2'/><small style={{ color: '#fff',textDecoration:"none"}}>+91 8999 999 108</small></a><br></br> */}
          <p style={{lineHeight:"1.9em",paddingTop:"10px"}}> Shop No. 10, Sony Complex, Prashanthi <br />Nagar,
          Ind. Estate, Kukatpally,<br></br>Hyderabad, Telangana 500072</p>
        </div>
        <div className="footer-right">
          <div className="footer-links">
            {/* <a href="#">Privacy Policy</a><br></br>
            <a href="#">Terms and Conditions</a><br/> */}
            <div className="footer-social text-end">
            <a href="" target='_blank' className="icon"><img src={fb}/></a>
            <a href="" target='_blank'><i className="icon"><img src={linkedin}/></i></a>
            <a href="" target='_blank'><i className="icon"></i><img src={call}/></a>
            <a href=""><i className="https://www.instagram.com/axissolarsystems/?next=%2Fexplore%2Flocations%2F105539444571052%2Faxis-enertech%2F" target="_blank"></i><img src={insta}/></a>
            <a href=""><i className="icon"></i><img src={youtube}/></a>
          </div>
          </div>
         
        </div>
      </div>
      <div className=''>
      <div className="footer-bottom text-start " >
        <a href='' target='_blank'style={{color:"#fff",whiteSpace:"nowrap"}}>Copyright © Axis Solar</a>
        <div className="designed text-end" >
        <a href='https://anjusiimatechnologies.com/' target='_blank'style={{color:"#fff",whiteSpace:"nowrap"}}>Designed & Developed By<div > Anju Siima Technologies Pvt Ltd</div></a>
            {/* <a href="#" className="icon"><img src={fb}/></a>
            <a href="#"><i className="icon"><img src={linkedin}/></i></a>
            <a href="#"><i className="icon"></i><img src={call}/></a>
            <a href="#"><i className="icon"></i><img src={insta}/></a>
            <a href="#"><i className="icon"></i><img src={youtube}/></a> */}
          </div>
          </div>
      </div>
    </footer>
  );
}

export default Footer;
